<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 1024px; height: 768px;" data-cy="medical-info-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="medical-info-header-section">
      <div class="section-header-title" data-cy="medical-info-title-text">
        Appointment Medical Information
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; overflow-y: auto;" data-cy="medical-info-content-section">
      <app-forms-form *ngIf="CaseWorkItemFormsId" [CaseWorkItemFormsId]="CaseWorkItemFormsId" data-cy="medical-info-forms-component"></app-forms-form>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="medical-info-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="medical-info-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="medical-info-ok-button">Ok</button>
    </div>
  </div>
</div>
